import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSongkickBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSongkickBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e2682c8bc71c2e5df276bc24c786429193e4bd63', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e80d222d28f6421b3edb18c566e5c9f80b672f3d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1191004fc17c770c34a89b70e713354f4acd6539', d: "M6.912 16.086c-1.392 0-2.529-.256-3.448-1.203l1.43-1.43c.473.472 1.303.638 2.03.638.882 0 1.302-.293 1.302-.817 0-.217-.05-.396-.178-.537-.115-.115-.306-.205-.6-.243L6.35 12.34c-.805-.115-1.417-.383-1.826-.805-.422-.434-.626-1.047-.626-1.825 0-1.66 1.251-2.874 3.32-2.874 1.303 0 2.286.307 3.065 1.086L8.878 9.327c-.575-.575-1.328-.536-1.724-.536-.779 0-1.098.447-1.098.843 0 .115.039.28.18.421.114.115.305.23.625.268l1.097.154c.818.114 1.405.37 1.789.753.485.472.676 1.149.676 1.993 0 1.852-1.596 2.863-3.511 2.863M17.608 3.989c-1.223-.915-2.58-1.53-4.291-1.811v8.156l2.445-3.405h2.674l-3.08 4.291s.708 1.132 1.132 1.804c.433.677.847.86 1.475.86.187 0 .187.002.425.002v2.11l-.654.002c-1.356 0-2.173-.247-2.785-1.184-.38-.606-1.632-2.572-1.632-2.572v3.746h-2.235V2h-.083c-2.889 0-4.881.696-6.607 1.989C1.902 5.853 2 8.339 2 10.998s-.1 5.15 2.39 7.014C6.119 19.305 8.112 20 11 20s4.882-.695 6.609-1.988c2.49-1.864 2.39-4.353 2.39-7.014 0-2.66.1-5.145-2.39-7.01", fill: "#F80046" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-songkick-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-songkick-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-songkick-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSongkickBranded$1);
            }
            break;
    } });
}

const CosmosIconSongkickBranded = CosmosIconSongkickBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSongkickBranded, defineCustomElement };
